// extracted by mini-css-extract-plugin
export default {"tableStyle":"QuestionsTableDetail_tableStyle__uQ4FQ"};